import React from 'react';
import { Header } from './components/Header';
import { Advertorial } from './components/Advertorial';
import { Footer } from './components/Footer';
export function App() {
  return <div className="flex flex-col min-h-screen bg-gray-50" data-id="element-0">
      <div className="max-w-3xl mx-auto w-full bg-white shadow-sm" data-id="element-1">
        <Header data-id="element-2" />
        <Advertorial data-id="element-3" />
        <Footer data-id="element-4" />
      </div>
    </div>;
}